import { render, staticRenderFns } from "./micoapp_basicinfo.vue?vue&type=template&id=1e2041cd&scoped=true"
import script from "./micoapp_basicinfo.vue?vue&type=script&lang=js"
export * from "./micoapp_basicinfo.vue?vue&type=script&lang=js"
import style0 from "./micoapp_basicinfo.vue?vue&type=style&index=0&id=1e2041cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2041cd",
  null
  
)

export default component.exports